import styled from 'styled-components';

export const PanelContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px;
  position: relative;
  margin: -10px;
`;

export const StyledTextarea = styled.textarea`
  color: #6A6B6B;
  background: #FFF;
  border: 2px solid #dddddd;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 10px;
  outline: none;
  resize: none;
  min-width: 400px;
  min-height: 150px;
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const InputFileWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
`;
